import * as Sentry from "@sentry/browser";
import { store } from "../../index"
import { getUserId } from "../../actions/user"

const error = (
  /** specify a meaningful error code that will make sense in Sentry */
  errorCode: string,
  /** append any data to help diagnose faults. DO NOT send PII or large data */
  debuginfo: Record<string, any>,
) => {
  Sentry.captureException(new Error(`bferror ${errorCode}`), (scope) => {
    scope.setUser({ id: getUserId(store.getState()) });
    scope.setTag("bfevent", "bug");
    scope.setContext("debuginfo", debuginfo);
    return scope;
  });
};

const breadcrumb = (breadcrumb: Sentry.Breadcrumb) => {
  Sentry.addBreadcrumb(breadcrumb);
};

export const sentryApi = {
  error,
  breadcrumb,
};
